"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
var react_1 = require("react");
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var lodash_1 = require("lodash");
var useResizeObserver = function (_a) {
    var elementRef = _a.element, _b = _a.wait, wait = _b === void 0 ? 100 : _b;
    var _c = (0, react_1.useState)({ width: 0, height: 0 }), size = _c[0], setSize = _c[1];
    var observerRef = (0, react_1.useRef)(null);
    var callback = (0, react_1.useMemo)(function () {
        return (0, lodash_1.throttle)(function (entries) {
            var height = 0;
            var width = 0;
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                if (entry.contentBoxSize) {
                    // Firefox implements `contentBoxSize` as a single content rect, rather than an array
                    var contentBoxSize = Array.isArray(entry.contentBoxSize)
                        ? entry.contentBoxSize[0]
                        : entry.contentBoxSize;
                    height = contentBoxSize.blockSize;
                    width = contentBoxSize.inlineSize;
                }
                else {
                    height = entry.contentRect.height;
                    width = entry.contentRect.width;
                }
            }
            if (size.width !== width || size.height !== height) {
                setSize({
                    height: height,
                    width: width,
                });
            }
        }, wait);
    }, [setSize, wait, size]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var element = elementRef.current;
        if (elementRef.current) {
            (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.unobserve(element);
        }
        var ResizeObserverOrPolyfill = resize_observer_polyfill_1.default;
        observerRef.current = new ResizeObserverOrPolyfill(callback);
        if (elementRef.current) {
            (_b = observerRef.current) === null || _b === void 0 ? void 0 : _b.observe(element);
        }
        return function () {
            var _a;
            if (elementRef.current) {
                (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.unobserve(element);
            }
        };
    }, [elementRef, wait, observerRef]);
    return { size: size };
};
exports.useResizeObserver = useResizeObserver;
